module.exports = __webpack_public_path__ + "791a1220.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/articles/leasing/passport.png
// module id = 3203
// module chunks = 21